module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABGdBTUEAALGPC/xhBQAAAK5JREFUOBFjYKARYCTGXMn2/4uB6jShaq8/r2SMJaSPhZACqLzm//8MxiA2I1FOYWBgItJgkpWNGgwPsqEXFODEg5ZO4d5BYmgAkxs3iA9Mbl+B1A0kOXQmOJ3D0jE8naKrQudDLQCnaXQ5EB+WzmkWxjAXX4fZhM0VQDGSggLschwGoQgD4+AMUpY+CywrTFAUYOHQLChGDYaH9tALClg6hnsBBwM5nV/HoYY+wgBNAiOC3iGRvAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/plus_lightgray_transparent_11_11.png
// module id = ./src/_asset/sources/assets/images/plus_lightgray_transparent_11_11.png
// module chunks = main